import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authApi, formatApiError } from "../lib/api";
import { toast } from "sonner";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = unknown / loading, false = unauth, object = authed
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!authApi.hasToken()) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const u = await authApi.me();
      setUser(u);
    } catch {
      authApi.logout();
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    try {
      const u = await authApi.login(email, password);
      setUser(u);
      toast.success(`Welcome back, ${u.name || "Admin"}`);
      return true;
    } catch (e) {
      const msg = formatApiError(e.response?.data?.detail) || e.message;
      toast.error(msg);
      return false;
    }
  };

  const logout = () => {
    authApi.logout();
    setUser(false);
    toast.success("Signed out.");
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
